import { DEFAULT_HOSTING_BASE } from './constants.js';

/**
 * Normalise a base URL: ensure it ends with exactly one slash.
 */
export const normaliseBase = (canonicalBase) => {
  if (!canonicalBase || !canonicalBase.trim()) return DEFAULT_HOSTING_BASE;
  return canonicalBase.trim().endsWith('/') ? canonicalBase.trim() : canonicalBase.trim() + '/';
};

/**
 * Build the full canonical URL for a given filename.
 */
export const buildCanonicalUrl = (filename, canonicalBase) => {
  return normaliseBase(canonicalBase) + filename;
};

/**
 * Replace ALL occurrences of the default hosting base URL in the HTML with the
 * custom base URL (or leave unchanged if no custom base is provided).
 *
 * STRICT MODE: This will ONLY replace existing <link rel="canonical"> tags
 * and will NOT inject new ones into the <head> if they are missing.
 */
export const injectCanonicalPatcher = (html, filename, changes, canonicalBase) => {
  let out = html;
  const base = normaliseBase(canonicalBase);
  const fullUrl = `${base}${filename}`;

  // ── 1. Replace existing <link rel="canonical"> ────────────────────────────
  const canonicalTagRx = /(<link[^>]*rel=["']canonical["'][^>]*href=["'])([^"']+)(["'][^>]*>)/gi;
  const replaced = out.replace(canonicalTagRx, `$1${fullUrl}$3`);

  if (replaced !== out) {
    out = replaced;
    changes.push(`[canonical] Set canonical href → ${fullUrl}`);
  } else {
    changes.push(
      `[canonical] WARNING: No existing <link rel="canonical"> found. Skipping injection per strict rules.`
    );
  }

  // ── 2. Replace og:url meta tag ────────────────────────────────────────────
  const ogUrlRx = /(<meta[^>]*property=["']og:url["'][^>]*content=["'])([^"']*)(["'][^>]*>)/gi;
  const ogReplaced = out.replace(ogUrlRx, `$1${fullUrl}$3`);

  if (ogReplaced !== out) {
    out = ogReplaced;
    changes.push(`[canonical] Set og:url → ${fullUrl}`);
  }

  // Note: The global sweep of the default hosting base is safely handled 
  // earlier in transforms.js (Step B) which protects .mp4 video URLs from 
  // being accidentally overwritten by the canonical base.

  return out;
};